function parseNewLines(text: string) {
    return text?.replace(/([^\n])\n([^\n])/g, '$1\n\n$2');
}

export {parseNewLines};
